import { C, metalGradient, wrap } from '../styles';

const FooterLogo = () => (
  <svg width="30" height="25" viewBox="0 0 100 82" fill="none">
    <path d="M0,70 L0,0 L14,0 L29,30 L44,0 L58,0 L58,70 L45,70 L45,44 L29,57 L13,44 L13,70 Z" fill="#2C3F50" />
    <polygon points="29,16 21,30 29,38 37,30" fill="#3297DB" />
    <rect x="64" y="0" width="9" height="70" rx="2" fill="#2C3F50" />
    <rect x="64" y="0" width="9" height="14" rx="2" fill="#3297DB" />
  </svg>
);

const linkStyle = { color: C.navy, textDecoration: 'none', fontWeight: 600 };
const contactRow = { fontSize: 13, color: C.mut };

export default function Footer() {
  return (
    <footer style={{ borderTop: `1px solid ${C.bdr}`, padding: '36px 0', background: C.dark }}>
      <div style={wrap}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <FooterLogo />
            <span style={{ ...metalGradient, fontSize: 16 }}>MetalMatch</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', color: C.steelder }}>Get in touch</span>
            <span style={contactRow}>General inquiries: <a href="mailto:info@getmetalmatch.com" style={linkStyle}>info@getmetalmatch.com</a></span>
            <span style={contactRow}>Quotes: <a href="mailto:quotes@getmetalmatch.com" style={linkStyle}>quotes@getmetalmatch.com</a></span>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginTop: 24 }}>
          <p style={{ fontSize: 11, color: C.dim, margin: 0 }}>© {new Date().getFullYear()} MetalMatch. Ontario, Canada.</p>
          <p style={{ fontSize: 11, color: C.dim, margin: 0 }}>Custom metal fabrication · Ontario, Canada</p>
        </div>
      </div>
    </footer>
  );
}
